import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/layout/Header";
import ApprovedUsers from "../components/home/ApprovedUsersAll";
import Footer from "../components/layout/footer";

const Athletes: React.FC = () => {
  const navigate = useNavigate();

  // Only render the Hero if not a PWA install
  return (
    <div className="min-h-screen bg-gray-100">
      <Header></Header>
      {/* Athletes Section */}
      <section className="py-52 bg-gray-50">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl lg:text-center">
            <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              Our Athletes
            </p>
          </div>
          <div className="mt-6">
            <ApprovedUsers />
          </div>
        </div>
      </section>
      <Footer></Footer>
    </div>
  );
};

export default Athletes;
